import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormatLocalDate } from "../Formatters";
import UserLink from "../UserLink/UserLink";

export const Metadata = ({
  projectName,
  projectId,
  createdById,
  createdByName,
  createdByEmail,
  createdOn,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("tw-flex tw-items-center", className)}>
      <Caption1
        color="tertiary"
        className="tw-pr-3 tw-mr-3 tw-border-border-primary tw-border-0 tw-border-solid tw-border-r"
      >
        <Link
          className="tw-no-underline tw-text-theme-600 hover:tw-text-secondary"
          to={`/projects/${projectId}`}
        >
          {projectName}
        </Link>
      </Caption1>
      <Caption1 color="tertiary">
        {t("Started by")}{" "}
        <UserLink
          id={createdById}
          hideAvatar
          renderAs={Caption1}
          email={createdByEmail}
          nameProps={{
            color: "tertiary",
          }}
          name={createdByName}
          context="disscusion - started-by"
        />{" "}
        {t("on")}{" "}
        <FormatLocalDate
          value={createdOn}
          long={false}
        />
      </Caption1>
    </div>
  );
};

Metadata.propTypes = {
  createdById: PropTypes.number,
  createdByName: PropTypes.string.isRequired,
  createdByEmail: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  createdOn: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  className: PropTypes.string,
};
